class SizeCharts extends HTMLElement {
  constructor() {
    super();
    this.viewModel = this.getViewModel();
    this.dynamicRender = this.hasAttribute('data-dynamic-source');
    this.bindEvents(this);

    if (this.dynamicRender) this.patchModalOpen();
  }

  bindEvents(target) {
    this.parseAttributes(target);
    this.hideSizeCharts();
    this.hideIrrelevantHeadings();
    this.bindTabHandlers();
    this.showRelevantSizeChart();
    this.setTitle();
  }

  setTitle() {
    const { $modalTitle } = this.viewModel;

    if (this.modalTitle && $modalTitle) {
      $modalTitle.textContent = this.modalTitle;
    }
  }

  patchModalOpen() {
    const { $modal } = this.viewModel;
    if (!$modal || typeof $modal.open !== 'function') return;

    if (this._originalModalOpen) return;

    this._originalModalOpen = $modal.open;

    $modal.open = (...args) => {
      const target = args[0];
      this.bindEvents(target);

      return this._originalModalOpen.apply($modal, args);
    };
  }

  getViewModel() {
    return {
      $ringsHeading: this.querySelector('#rings-heading-section'),
      $adultKidsHeading: this.querySelector('#adult-kids-heading-section'),
      $tabs: this.querySelectorAll('.tab'),
      $tabContents: this.querySelectorAll('.tab-content'),
      $modal: this.closest('modal-slideout'),
      $modalTitle: this.closest('modal-slideout').querySelector('.modal__header-title'),
      $sizeCharts: this.querySelectorAll('[id*="SizeChart"]'),
    };
  }

  parseAttributes(target) {
    this.sizeGuide = target.getAttribute('data-size-guide')?.toLowerCase() || 'adult'; // "Expect values: Adult, Kids"
    this.gender = target.getAttribute('data-gender')?.toLowerCase() || ''; // "Expect values: Mens, Womens, Unisex, Boys, Girls"
    this.modalTitle = target.getAttribute('data-size-chart-title') || '';
    this.kidsAge = target.getAttribute('data-kid-age')?.toLowerCase() || ''; // "Expect values: Big, Little, Infant"
    this.sizeChartType = target.getAttribute('data-size-chart-type')?.toLowerCase() || 'footwear'; // "Expect values: Footwear, Rings, Tops, Bottons, Belts, Hats"
    this.genderValue = this.gender === 'unisex' || this.gender === '' ? 'womens' : this.gender;
  }

  hideIrrelevantHeadings() {
    const { $ringsHeading, $adultKidsHeading } = this.viewModel;

    const hideRings = !['rings'].includes(this.sizeChartType);
    const hideAdultKids = ['rings', 'tops', 'bottoms', 'hats', 'belts'].includes(this.sizeChartType);

    if ($ringsHeading) $ringsHeading.style.display = hideRings ? 'none' : 'block';
    if ($adultKidsHeading) $adultKidsHeading.style.display = hideAdultKids ? 'none' : 'block';
  }

  // Initial state for all charts
  hideSizeCharts() {
    this.viewModel.$sizeCharts?.forEach((el) => {
      el.style.display = 'none';
    });
  }

  showRelevantSizeChart() {
    const show = (id) => {
      const el = this.querySelector(id);
      if (el instanceof HTMLElement) el.style.display = 'block';
    };

    if (['rings', 'hats', 'belts'].includes(this.sizeChartType)) {
      show(`#${this.sizeChartType}SizeChart`);
      this.activateTab(`${this.genderValue}-${this.sizeChartType}`);
    } else if (['tops', 'bottoms'].includes(this.sizeChartType)) {
      show(`#${this.sizeChartType}SizeChart`);
    } else if (this.sizeGuide === 'kids') {
      show(`#${this.sizeGuide}SizeChart`);
      this.activateTab(this.kidsAge);
    } else {
      show(`#${this.sizeGuide}SizeChart`);
      this.activateTab(this.genderValue);
    }
  }

  activateTab(id) {
    const tab = this.querySelector(`#${id}`);

    if (tab instanceof HTMLElement) {
      tab.click();
    }
  }

  bindTabHandlers() {
    const { $tabs, $tabContents } = this.viewModel;

    $tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        $tabs.forEach((item) => {
          item.classList.remove('tab-active');
          item.firstElementChild?.classList.replace('fixed-utility-m-em', 'fixed-utility-m');
        });

        $tabContents.forEach((content) => content.classList.remove('active'));

        tab.classList.add('tab-active');
        tab.firstElementChild?.classList.replace('fixed-utility-m', 'fixed-utility-m-em');

        const content = this.querySelector(`#tab-content-${tab.id}`);
        if (content instanceof HTMLElement) {
          content.classList.add('active');
        }
      });
    });
  }
}

customElements.define('size-charts', SizeCharts);
